import { Dimensions, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { hasStoredParcels } from '~/apps/smartsend/lib/parcels/itemView';

export function DimensionsAreValid(dimensions: Dimensions, dimensionsRequired: boolean) {
  return (
    dimensions.Weight > 0 &&
    (!dimensionsRequired || (dimensions.Height > 0 && dimensions.Length > 0 && dimensions.Width > 0))
  );
}

/**
 * Whether the parcel-count control should be offered.
 *
 * The weight gate belongs only to the FIRST single-to-multi conversion: GenerateConsignmentFromItem
 * divides the item's weight across the parcels it creates, which is meaningless at zero. Every
 * subsequent count change goes through RedistributeConsignmentParcels, which works from the existing
 * content rows and needs no item weight.
 *
 * Gating on the item's dimensions once parcels exist was also unreachable rather than merely strict:
 * nothing writes the parcels' L/W/H back onto the item, PackageDimensions.Weight is only recomputed
 * in-session by ItemDetails.updateConsignment, and ConsignmentDetails hides the item-level
 * DimensionsSelection whenever a consignment exists - so the panel demanded a value it gave no way to
 * enter, and correct per-parcel weights could not clear it.
 *
 * A weightless PARCEL is still reported: ConsignmentSummary renders the ITEM-/PRODUCT- errors from
 * PostQuoteValidation with a Fix Issues button into the parcel editor, which is where that weight lives.
 *
 * hasStoredParcels rather than `!!item.Consignment` on purpose - a { Parcels: [] } consignment stores
 * nothing, so it keeps the single-parcel gate.
 */
export const ConsignmentOptionsAreAvailable = (
  item: SmartSendItemApiModel,
  dimensions: Dimensions,
  dimensionsRequired: boolean
): boolean => hasStoredParcels(item) || DimensionsAreValid(dimensions, dimensionsRequired);
